export default __webpack_public_path__ + "static/media/ammActive.e6f204fe.svg";